import React, { useState, useEffect } from 'react';
import ApexColumnChart from '../common/charts/columnChart/calumnChart';
import Indicate from '../common/cards/Indicate';
import DeviceTypeChart from '../common/charts/DeviceTypeChart';
import { AnalyticsData } from '../../pages/Analytics';
import millify from 'millify';
import useI18n from '../../hooks/useI18n';

interface ChartSectionProps {
  analyticsData: AnalyticsData;
  view?: 'daily' | 'weekly' | 'monthly' | 'yearly';
}

const ChartSection: React.FC<ChartSectionProps> = ({
  analyticsData,
  view = 'weekly',
}) => {
  const { t } = useI18n();
  const [localView, setLocalView] = useState<
    'daily' | 'weekly' | 'monthly' | 'yearly'
  >(view);

  useEffect(() => {
    setLocalView(view);
  }, [view]);

  return (
    <div>
      <h2 className="font-[500] mt-[16px] mb-[8px] text-[#121111]">
        {String(t('analytics.chartAnalysis'))}
      </h2>
      <div className="flex flex-col md:flex-row gap-[20px]">
        <div className="w-full md:w-1/2 border rounded-3xl bg-white flex flex-col justify-between relative overflow-hidden">
          <div className="flex flex-col lg:flex-row items-start lg:justify-between lg:items-center p-[18px]">
            <div className="w-full">
              <span className="text-[#4C4C4C] text-sm leading-5 font-[Inter]">
                {String(t('analytics.userVisit'))}
              </span>
              <div className="flex items-center">
                <h2 className="text-2xl text-[#292828] mr-2 font-semibold">
                  {millify(analyticsData.totalClicked.count)}
                </h2>
                <span className="inline-flex">
                  <Indicate
                    direction={
                      analyticsData.totalClicked.changeInPercentage >= 0
                        ? 'up'
                        : 'down'
                    }
                    percent={
                      analyticsData.totalClicked.changeInPercentage === 0
                        ? analyticsData.totalClicked.changeInPercentage
                        : +analyticsData.totalClicked.changeInPercentage.toFixed(
                            2,
                          )
                    }
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="h-full">
            <ApexColumnChart
              timeFrameView={analyticsData.timeFrameView}
              view={localView}
            />
          </div>
        </div>
        <div className="w-full md:w-1/2 border rounded-3xl bg-white flex flex-col lg:h-[480px]">
          <div className="p-[18px]">
            <span className="text-[#4C4C4C] text-sm leading-5 font-[Inter]">
              {String(t('analytics.linkOpensByDevice'))}
            </span>
          </div>
          <div className="flex-grow">
            {Object.values(analyticsData.deviceTypeDistribution).some(
              (item) => item,
            ) ? (
              <DeviceTypeChart
                deviceData={analyticsData.deviceTypeDistribution}
              />
            ) : (
              <div className="flex items-center justify-center h-full w-full">
                <span className="text-gray-500 text-lg font-semibold">
                  {String(t('common.noData'))}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChartSection;
